<template>
    <li style="width: 300px; height: 135px" class="leo-dropdown-cart-item clearfix has-view-additional first last"
        :class="{ 'show-additional': showSizes }">
        <div class="leo-cart-item-img">
            <a class="label" href="javascript:void(0)" :title="title">
                <img class="img-fluid" :src="productImage" :alt="title" :title="title">
            </a>

        </div>
        <div class="leo-cart-item-info">
            <div class="product-name">
                <a class="label"
                    href="javascript:void(0)"
                    :title="title">
                    {{ title }}
                </a>
            </div>
            <div class=" d-flex justify-items-center">
                <div class="product-quantity w-100" style="border: 0;">
                    <div class="leo-input-product-quantity d-flex w-auto" style="border: 0;">
                        {{ quantity }} X {{ itemPrice }}
                    </div>
                </div>
                <div class="product-price w-50">
                    <div class="current-price d-flex w-100">
                        <span class="price d-flex w-auto">BDT {{ itemSubtotal }}</span>
                    </div>
                </div>
            </div>

            <!-- <div class="product-quantity">
                <a href="javascript:void(0)" class="leo-bt-product-quantity leo-bt-product-quantity-down"><i
                        class="material-icons"></i></a>
                <input class="leo-input-product-quantity input-group"
                    data-down-url="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/cart?update=1&amp;id_product=1&amp;id_product_attribute=8&amp;token=db62e42ed679a2b3256f637c8b160d22&amp;op=down"
                    data-up-url="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/cart?update=1&amp;id_product=1&amp;id_product_attribute=8&amp;token=db62e42ed679a2b3256f637c8b160d22&amp;op=up"
                    data-update-url="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/cart?update=1&amp;id_product=1&amp;id_product_attribute=8&amp;token=db62e42ed679a2b3256f637c8b160d22"
                    data-id-product="1" data-id-product-attribute="8" data-id-customization="" data-min-quantity="1"
                    data-product-quantity="1" data-quantity-available="300" type="text" value="1" min="1">

                <a href="javascript:void(0)" class="leo-bt-product-quantity leo-bt-product-quantity-up"><i
                        class="material-icons"></i></a>
            </div> -->
        </div>
        <a class="leo-remove-from-cart" href="javascript:void(0)" title="Remove from cart" @click.prevent="cartStore.removeCartItem(item)">
            <i class="material-icons"></i>
        </a>
        <div class="view-additional">
            <!-- <div class="view-leo-dropdown-additional" :class="{show: showSizes}" @click.prevent="showSizes = !showSizes"></div> -->
        </div>
        <div class="leo-dropdown-overlay">
            <div class="leo-dropdown-cssload-speeding-wheel">
            </div>
        </div>
        <div class="leo-dropdown-additional">

            <div class="view-combination label">

            </div>
            <div class="combinations">
                <div class="product-line-info">
                    <span class="label">Size:</span>
                    <span class="value">XL </span>
                </div>
                <div class="product-line-info">
                    <span class="label">Color:</span>
                    <span class="value">Black</span>
                </div>
            </div>
        </div>
    </li>
</template>

<script setup>
import {cartItemDto} from "@/composables/cart-details/cartItemDto.js";
import { useCartStore } from "@/stores/cart";
const cartStore = useCartStore();

const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
});

const showSizes = ref(false);
const { 
    id,
    productImage,
    title,
    productAttributes,
    productSize,
    productColor,
    price,
    quantity,
    subtotal,
} = cartItemDto(props.item);

const itemPrice = computed(() => (Number(price.value)).toFixed(2) ?? 0);

const itemSubtotal = computed(() => (Number(subtotal.value)).toFixed(2) ?? 0);
</script>
